import { render, staticRenderFns } from "./HomeAcceptance.vue?vue&type=template&id=285fe512&scoped=true&"
import script from "./HomeAcceptance.vue?vue&type=script&lang=js&"
export * from "./HomeAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./HomeAcceptance.vue?vue&type=style&index=0&id=285fe512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285fe512",
  null
  
)

export default component.exports